/*
  Cart actions for the Frey cart (snippets/cart-line-items.liquid, frey-cart-boosters.liquid):
  - [data-frey-booster-add]: adds one of the booster in the row's scent picker
  - [data-frey-booster-remove]: takes that booster's line out of the cart
  - [data-frey-cart-sub]: switches a line between one-time and its 30-day selling plan
  - [data-frey-booster-variant]: changing a booster's scent swaps its photo to that scent

  Speed: every cart change asks Shopify for the rendered cart drawer in the same request (the Section
  Rendering API, section "api-cart-items"), then hands it to the theme's own builder (window.cart.build).
  That's one round trip instead of the theme's two (change, then fetch the cart). The theme's Add to
  cart, quantity and Remove go through the same path: window.cart.addToCart and .updateCart are
  swapped for versions that do this, falling back to the theme's own when anything is missing.

  Feel: Shopify takes around a second to apply a cart change on this store (its cart apps run on every
  change), so the cart answers straight away and fills in when Shopify confirms: Add to cart opens the
  drawer at once with an "Adding to your cart…" row, a removed line collapses at once, and a booster's
  Add/Added flips on tap.
*/
(function () {
  var CART_SECTION = 'api-cart-items';

  // Hand a Cart API response that carries the rendered cart to the theme's builder
  function buildFrom(json) {
    var cart = window.cart;
    var html = json && json.sections && json.sections[CART_SECTION];
    if (!cart || typeof cart.build !== 'function' || !html) return false;
    if (cart.cartDrawer && !cart.isCartDrawerLoaded && typeof cart.renderCartDrawer === 'function') {
      cart.renderCartDrawer(false);
    }
    var holder = document.createElement('div');
    holder.innerHTML = html;
    var content = holder.querySelector('[data-api-content]');
    if (!content) return false;
    cart.build(content);
    return true;
  }

  function refresh(json) {
    if (buildFrom(json)) return;
    if (window.cart && typeof window.cart.getCart === 'function') {
      window.cart.getCart();
    } else {
      window.location.reload();
    }
  }

  function post(route, body) {
    body.sections = CART_SECTION;
    body.sections_url = window.location.pathname;
    return fetch(route + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok || json.status) throw json;
        return json;
      });
    });
  }

  // The drawer opens right away with a placeholder row while the add goes through
  function showPending(cart) {
    if (cart.cartDrawer && !cart.isCartDrawerLoaded && typeof cart.renderCartDrawer === 'function') {
      cart.renderCartDrawer(false);
    }
    var holder = cart.itemsHolder || document.querySelector('[data-items-holder]');
    if (!holder) return null;
    var thumb = document.querySelector('.frey-pdp .frey-select__button .frey-select__thumb');
    var pending = document.createElement('div');
    pending.className = 'frey-cart-line frey-cart-line--pending';
    pending.setAttribute('role', 'status');
    pending.innerHTML =
      '<span class="frey-cart-line__image">' + (thumb && thumb.src ? '<img src="' + thumb.src + '" alt="">' : '') + '</span>' +
      '<div class="frey-cart-line__main"><p class="frey-cart-line__title">Adding to your cart…</p>' +
      '<span class="frey-cart-pending-bar"></span><span class="frey-cart-pending-bar frey-cart-pending-bar--short"></span></div>';
    var empty = document.querySelector('[data-empty-message]');
    var emptyWasShown = empty && !empty.classList.contains('hidden');
    if (empty) empty.classList.add('hidden');
    holder.classList.remove('hidden');
    holder.insertBefore(pending, holder.firstChild);
    if (typeof cart.openCartDrawer === 'function') cart.openCartDrawer();
    return function undo() {
      pending.remove();
      if (emptyWasShown && empty) {
        empty.classList.remove('hidden');
        holder.classList.add('hidden');
      }
    };
  }

  // One-request versions of the theme's add and update
  function patchThemeCart() {
    var cart = window.cart;
    if (!cart || cart.__freyFastCart || typeof cart.addToCart !== 'function' || typeof cart.updateCart !== 'function') return !!(cart && cart.__freyFastCart);
    cart.__freyFastCart = true;
    var themeAdd = cart.addToCart;
    var themeUpdate = cart.updateCart;

    cart.addToCart = function (data) {
      if (!cart.cartDrawerEnabled || !(data instanceof FormData) || cart.showCannotAddMoreInCart) return themeAdd(data);
      if (cart.button) {
        cart.button.classList.add('is-loading');
        cart.button.setAttribute('disabled', true);
      }
      data.append('sections', CART_SECTION);
      data.append('sections_url', window.location.pathname);
      var undoPending = showPending(cart);
      fetch(window.theme.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: data
      })
        .then(function (response) { return response.json(); })
        .then(function (json) {
          if (json.status) {
            if (undoPending) undoPending();
            if (typeof cart.closeCartDrawer === 'function') cart.closeCartDrawer();
            cart.addToCartError(json);
            cart.removeLoadingClass();
            return;
          }
          cart.hideAddToCartErrorMessage();
          if (!buildFrom(json)) cart.getCart();
          cart.scrollToCartTop();
        })
        .catch(function () {
          if (undoPending) undoPending();
          cart.getCart();
        });
    };

    cart.updateCart = function (updateData, currentItem) {
      updateData = updateData || {};
      var root = cart.cart;
      if (!root) return themeUpdate(updateData, currentItem);
      var item = root.querySelector('[data-item="' + updateData.id + '"]') || currentItem;
      var line = item && item.hasAttribute('data-item-index') ? parseInt(item.getAttribute('data-item-index'), 10) : 0;
      if (!line) return;
      if (currentItem) currentItem.classList.add(updateData.quantity ? 'is-loading' : 'is-removed');
      cart.disableCartButtons();
      cart.addLoadingClass();

      fetch(window.theme.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: updateData.quantity, sections: CART_SECTION, sections_url: window.location.pathname })
      })
        .then(function (response) {
          return response.json().then(function (json) { return { status: response.status, json: json }; });
        })
        .then(function (result) {
          if (result.status === 400) {
            cart.getCart();
            return;
          }
          if (result.json.errors) {
            cart.cartUpdateFailed = true;
            cart.updateErrorText(item ? item.getAttribute('data-item-title') : '');
            cart.toggleErrorMessage();
            if (currentItem) cart.resetLineItem(currentItem);
            cart.enableCartButtons();
            cart.removeLoadingClass();
            cart.scrollToCartTop();
            return;
          }
          if (!buildFrom(result.json)) cart.getCart();
        })
        .catch(function () {
          cart.enableCartButtons();
          cart.removeLoadingClass();
        });
    };
    return true;
  }

  // The theme creates window.cart as it starts up; patch as soon as it exists
  (function waitForCart(tries) {
    if (patchThemeCart() || tries > 40) return;
    setTimeout(function () { waitForCart(tries + 1); }, 100);
  })(0);

  // A booster's photo follows its scent picker
  document.addEventListener('change', function (event) {
    var picker = event.target.closest('[data-frey-booster-variant]');
    if (!picker) return;
    var image = picker.closest('[data-frey-booster]').querySelector('[data-frey-booster-image]');
    var src = picker.selectedOptions[0] && picker.selectedOptions[0].dataset.image;
    if (image && src) {
      image.removeAttribute('srcset');
      image.src = src;
    }
  });

  document.addEventListener('click', function (event) {
    var add = event.target.closest('[data-frey-booster-add]');
    var remove = event.target.closest('[data-frey-booster-remove]');
    var sub = event.target.closest('[data-frey-cart-sub]');
    var control = add || remove || sub;
    if (!control || control.disabled) return;
    event.preventDefault();

    var request;
    if (add) {
      var picker = add.closest('[data-frey-booster]').querySelector('[data-frey-booster-variant]');
      var id = Number(picker ? picker.value : add.dataset.variant);
      request = post(window.theme.routes.cart_add_url, { items: [{ id: id, quantity: 1 }] });
    } else if (remove) {
      request = post(window.theme.routes.cart_change_url, { id: remove.dataset.freyBoosterRemove, quantity: 0 });
    } else {
      var subscribe = sub.getAttribute('aria-checked') !== 'true';
      sub.setAttribute('aria-checked', subscribe ? 'true' : 'false');
      request = post(window.theme.routes.cart_change_url, {
        line: Number(sub.dataset.line),
        quantity: Number(sub.dataset.quantity),
        selling_plan: subscribe ? Number(sub.dataset.plan) : null
      });
    }

    // Answer the tap straight away; the cart redraw that follows confirms it
    if (add || remove) {
      var row = control.closest('[data-frey-booster]');
      if (row) row.classList.toggle('is-added', !!add);
      control.setAttribute('aria-pressed', add ? 'true' : 'false');
      control.textContent = add ? '✓ Added' : 'Add';
    }
    control.disabled = true;
    control.setAttribute('aria-busy', 'true');
    request.then(refresh, function () { refresh(); });
  });
})();
